/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Quick_Sale_Publish_UnavailableInputs */

const vi_einvoice_error_quick_sale_publish_unavailable = /** @type {(inputs: Einvoice_Error_Quick_Sale_Publish_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này không tự phát hành hóa đơn được: chỉ đơn Bán ngay vừa bán (trong 30 phút) có tích hóa đơn, do chính bạn bán, với bản nháp chưa bị sửa. Hãy xem nháp rồi phát hành tay.`)
};

/**

* @param {Einvoice_Error_Quick_Sale_Publish_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_quick_sale_publish_unavailable = /** @type {((inputs?: Einvoice_Error_Quick_Sale_Publish_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Quick_Sale_Publish_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_quick_sale_publish_unavailable(inputs)
});